import { createTRPCNuxtClient, httpLink } from 'trpc-nuxt/client'
import type { AppRouter } from 'server/api/routers';

export default defineNuxtPlugin({
    name: "trpc",
    async setup() {
        const runtimeConfig = useRuntimeConfig();
        const link = httpLink({
            url: runtimeConfig.public.API_BASE_URL,
            fetch(url, options) {
                return fetch(url, {
                    ...options,
                    credentials: 'include',
                })
            },
        });
        const client = createTRPCNuxtClient<AppRouter>({
            transformer: undefined,
            links: [link]
        });
        return {
            provide: { client }
        }
    }
})
